import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AttachmentType } from '../../../enums';

@Component({
	selector: 'add-transport-waybill',
	templateUrl: './add-transport-waybill.component.html'
})
export class AddTransportWaybillComponent {
	@Input()
	requestId: number;

	@Output()
	onContinueEvent: EventEmitter<void> = new EventEmitter<void>();

	public visibleAttachmentTypes: number[] = [<number>AttachmentType.transportWaybill];
	public isTransportWaybillLoaded = false;

	constructor(public dialog: DialogRef) {
	}

	public filesLoaded(filesCount: number): void {
		this.isTransportWaybillLoaded = filesCount > 0;
	}

	public apply(): void {
		this.onContinueEvent.emit();
		this.cancel();
	}

	public cancel(): void {
		if (this.dialog) {
			this.dialog.close();
		}
	}
}
